@if (steps().length > 0) {
  <nav class="ui-step-validation" [attr.aria-label]="ariaLabel()">
    <ol class="ui-step-validation__list">
      @for (step of steps(); track step.id; let index = $index) {
        <li class="ui-step-validation__item">
          @if (interactive()) {
            <button
              type="button"
              class="ui-step-validation__step"
              [class.ui-step-validation__step--review]="step.status === 'review'"
              [class.ui-step-validation__step--observations]="step.status === 'observations'"
              [class.ui-step-validation__step--rejected]="step.status === 'rejected'"
              [class.ui-step-validation__step--validated]="step.status === 'validated'"
              [class.ui-step-validation__step--selected]="isSelected(step)"
              [attr.aria-current]="isSelected(step) ? 'page' : null"
              [attr.aria-label]="stepAriaLabel(step, index)"
              (click)="onStepSelect(step)"
            >
              <ng-container
                *ngTemplateOutlet="stepContent; context: { step: step, index: index }"
              />
            </button>
          } @else {
            <div
              class="ui-step-validation__step"
              [class.ui-step-validation__step--review]="step.status === 'review'"
              [class.ui-step-validation__step--observations]="step.status === 'observations'"
              [class.ui-step-validation__step--rejected]="step.status === 'rejected'"
              [class.ui-step-validation__step--validated]="step.status === 'validated'"
              [class.ui-step-validation__step--selected]="isSelected(step)"
              [attr.aria-current]="isSelected(step) ? 'page' : null"
              [attr.aria-label]="stepAriaLabel(step, index)"
              role="group"
            >
              <ng-container
                *ngTemplateOutlet="stepContent; context: { step: step, index: index }"
              />
            </div>
          }
        </li>
      }
    </ol>
  </nav>
}

<ng-template #stepContent let-step="step" let-index="index">
  <span class="ui-step-validation__marker" aria-hidden="true">
    @if (step.iconSrc) {
      <img class="ui-step-validation__icon-img" [src]="step.iconSrc" alt="" />
    } @else if (step.status === 'validated') {
      <svg class="ui-step-validation__icon" viewBox="0 0 24 24" focusable="false">
        <path d="M20 6 9 17l-5-5" />
      </svg>
    } @else if (step.status === 'rejected') {
      <svg class="ui-step-validation__icon" viewBox="0 0 24 24" focusable="false">
        <path d="m7 7 10 10M17 7 7 17" />
      </svg>
    } @else if (step.status === 'observations') {
      <svg class="ui-step-validation__icon" viewBox="0 0 24 24" focusable="false">
        <path d="M12 8v5m0 4h.01" />
      </svg>
    } @else if (step.status === 'review') {
      <img
        class="ui-step-validation__icon-img ui-step-validation__icon-img--status"
        src="/icons/ic_time.svg"
        alt=""
      />
    } @else if (showStepNumber()) {
      <span class="ui-step-validation__number">{{ index + 1 }}</span>
    } @else {
      <span class="ui-step-validation__dot"></span>
    }
  </span>

  <span class="ui-step-validation__body">
    <span class="ui-step-validation__eyebrow">Paso {{ index + 1 }}</span>
    <span class="ui-step-validation__label">{{ step.label }}</span>
    @if (showStatusLabel()) {
      <span class="ui-step-validation__statuses">
        <span class="ui-step-validation__status">
          {{ statusLabel(step.status) }}
        </span>
        @if (showStatusCount() && step.count !== undefined) {
          <span class="ui-step-validation__count">{{ step.count }}</span>
        }
      </span>
    }
  </span>
</ng-template>
